import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.8334 2.5C8.92961 2.5 3.33336 8.09625 3.33336 15C3.33336 21.9037 8.92961 27.5 15.8334 27.5C22.7371 27.5 28.3334 21.9037 28.3334 15C28.3334 8.09625 22.7371 2.5 15.8334 2.5ZM16.4584 21.25H15.2084C14.8634 21.25 14.5834 20.97 14.5834 20.625V19.375C14.5834 19.03 14.8634 18.75 15.2084 18.75H16.4584C16.8034 18.75 17.0834 19.03 17.0834 19.375V20.625C17.0834 20.97 16.8034 21.25 16.4584 21.25ZM15.8334 16.25C15.1434 16.25 14.5834 15.69 14.5834 15V10C14.5834 9.31 15.1434 8.75 15.8334 8.75C16.5234 8.75 17.0834 9.31 17.0834 10V15C17.0834 15.69 16.5234 16.25 15.8334 16.25Z",
		fill: "#FF5853"
	})]
});
const ForwardRef = forwardRef(SvgError);
export { ForwardRef as ReactComponent };
